import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { StoreService } from "../services/store.service";
@Injectable()
export class MobileAuthGuard {
    constructor(
        private router: Router,
        private storeService: StoreService
    ) {}
    canActivate(): boolean {
        let mobileToken = this.storeService.get("m-token");

        if (mobileToken && mobileToken !== "null" && mobileToken !== "undefined") {
            return true;
        } else {
            this.router.navigate(["/auth/login"]);
            return true;
        }
    }
}
